import { faFlowerTulip } from "@jewlr/pro-light-svg-icons/faFlowerTulip"
import { faGift } from "@jewlr/pro-light-svg-icons/faGift"
import { faShippingFast } from "@jewlr/pro-light-svg-icons/faShippingFast"
// import { faBoxHeart } from "@jewlr/pro-regular-svg-icons/faBoxHeart"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { jewlr_t, IS_JEWLR } from "helpers/application"
import { showHolidayShipMethodPDP } from "helpers/holiday"
import { cn } from "styles/utils"

const StyledTitle = ({ className = "", cutoffStyle = false, ...props }) => (
  <p
    className={cn(
      "text-16 tablet:text-18 font-semibold",
      cutoffStyle
        ? "tablet:font-bold tracking-tigher leading-16"
        : "tablet:font-medium",
      className
    )}
    {...props}
  />
)

StyledTitle.propTypes = {
  className: PropTypes.string,
  cutoffStyle: PropTypes.bool,
}

const InternalTitle = ({
  holidayDelivery,
  isAccessory,
  // minDeliveryDate,
  ship,
}) => {
  const holidayStyle = showHolidayShipMethodPDP && holidayDelivery
  const cutoffStyle = showHolidayShipMethodPDP && !holidayDelivery
  if (holidayStyle) {
    // const arriveBy =
    //   new Date(minDeliveryDate).getDate() ==
    //   new Date(sl.config.guaranteed_receive_date).getDate()
    const text =
      ship.view_type === "AVAILABLE_HOLIDAY"
        ? // ? ` Arrives ${arriveBy ? "By" : "Before"} ${
          `Arrives Before ${
            sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday
          }`
        : `${
            sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday
          } Shipping Info`
    // `${sl.config.guaranteed_holiday} ${jewlr_t("terms.Shipping")} Info`
    // const text = `${sl.config.guaranteed_holiday} Shipping Info`
    return (
      <div className="mb-12 flex items-center justify-center">
        {/* {false && (
          <Box
            as="img"
            height="20px"
            mr="4px"
            src={require("images/icons/tree.svg")}
            width="auto"
          />
        )} */}

        <FontAwesomeIcon
          className="text-black-print tablet:text-sale text-16 tablet:text-18 mr-8 align-text-top"
          icon={faFlowerTulip}
        />

        {/* {holidayStyle ? (
          <FontAwesomeIcon
            className="text-sale text-15 tablet:text-16 mr-8"
            icon={faFlowerTulip}
          />
        ) : (
          <FontAwesomeIcon
            className="text-green-darker tablet:text-sale text-16 tablet:text-18 mr-8 align-text-top"
            icon={faGift}
          />
        )} */}

        {/* <FontAwesomeIcon
            className="text-green-darker tablet:text-sale text-16 tablet:text-18 mr-8 align-text-top"
            icon={faGift}
          /> */}

        {/* <Image
          className="mr-4 w-auto"
          height="17"
          src={require("images/icons/doublehearts_bold.svg")}
          style={{ height: "20px" }}
          width="18"
        /> */}
        {/* <FontAwesomeIcon
          className="text-sale mr-4 w-auto"
          icon={faFlowerTulip}
          style={{ height: "14px" }}
        /> */}
        {/* <p className="font-bold text-green-darker text-18"/> */}
        <p className="text-16 tablet:text-18 tablet:font-medium tablet:tracking-tigher leading-20 text-black-print tablet:text-sale font-semibold">
          {text}
        </p>
      </div>
    )
  }
  return (
    <div
      className={cn(
        "flex items-center justify-center",
        cutoffStyle ? "mb-22 desktop:mb-10" : "mb-8"
      )}
    >
      {IS_JEWLR() ? (
        <>
          <FontAwesomeIcon
            className="text-18 mr-4 align-text-top"
            icon={faGift}
          />
          <StyledTitle cutoffStyle={cutoffStyle}>
            {isAccessory
              ? `${jewlr_t("terms.Shipping")} Information`
              : "Custom made for you!"}
          </StyledTitle>
        </>
      ) : (
        <>
          <FontAwesomeIcon
            className="text-22 mr-4 align-text-top"
            icon={faShippingFast}
          />
          <StyledTitle>{jewlr_t("terms.Shipping")} Info</StyledTitle>
        </>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    holidayDelivery: state.wizard.shipping.main?.available_holiday_delivery,
    isAccessory: state.wizard.description.product_type === "ACCESSORY",
    // minDeliveryDate: state.wizard.shipping.main?.min_delivery_date,
    ship: state.wizard.shipping.main,
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalTitle.propTypes = {
  holidayDelivery: PropTypes.bool,
  isAccessory: PropTypes.bool,
  // minDeliveryDate: PropTypes.string,
  ship: PropTypes.object,
}

const Title = connect(mapStateToProps, mapDispatchToProps)(InternalTitle)

export default Title
